import { useEffect, useRef, useState } from "react";
import { NavLink } from "react-router-dom";
import useIsMobile from '../hook/useIsMobile';

export default function Header({ headerStyle = 'normal' }) {
  const [isShowHeader, setIsShowHeader] = useState(true);
  const [isOpenMenu, setIsOpenMenu] = useState(false);
  
  const isOpenMenuRef = useRef(false);

  const isMobile = useIsMobile();

  const handleWheel = (e) => {
    const curY = e.deltaY;

    if (isOpenMenuRef.current) {
      setIsShowHeader(true);
    }
    else if (curY < 0 || window.scrollY === 0) {
      setIsShowHeader(true);
    }
    else {
      setIsShowHeader(false);
    }
  };

  const clickMenu = () => {
    setIsOpenMenu(prev => !prev);
    isOpenMenuRef.current = !isOpenMenuRef.current;
  }

  useEffect(() => {
    window.addEventListener('wheel', handleWheel);

    return () => {
      window.removeEventListener('wheel', handleWheel);
    }
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 w-full transition-transform duration-300 ease-in-out z-[50] 
        ${isShowHeader ? 'translate-y-0' : '-translate-y-full'}`}
    >
      <div className={`h-[90px] flex justify-between ${isOpenMenu && 'bg-opacity-80'} ${(headerStyle === 'normal' || isOpenMenu) && 'bg-white'}`}>
        <div className='w-full px-[5%] lg:px-[10%] flex justify-between items-center'>
          <NavLink to='/'>
            <img
              src={(headerStyle === 'white' && !isOpenMenu) ? '/logo_white.png' : '/logo.png'}
              alt='링콜'
              className='w-[42px] lg:w-[58px] aspect-auto'
            />
          </NavLink>

          <div 
            className={`hidden lg:flex items-center text-heading1 gap-[60px] ${headerStyle === 'white' ? '[&>*]:text-white' : '[&>*]:text-label-300'}`}>
            <div 
              onClick={() => window.open('https://www.module-link.com')} 
              className='hover:opacity-50 flex items-center gap-[4px] cursor-pointer'
            >
              만든 사람들
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path 
                d="M9.22173 7H16.9995M16.9995 7V14.7778M16.9995 7L6.99951 17" 
                stroke={headerStyle === 'white' ? '#FFF' : '#8D8D8D'} 
                strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
                />
              </svg>
            </div>
            <NavLink className='hover:opacity-50' to='/faq'>자주 하는 질문</NavLink>
            <NavLink className='hover:opacity-50' to='/contact'>문의하기</NavLink>
          </div>
          <div className='lg:hidden'>
            <svg 
              xmlns="http://www.w3.org/2000/svg"
              width="24" height="24" 
              viewBox="0 0 24 24" fill="none"
              onClick={clickMenu}
            >
              <path 
                d={isOpenMenu ? 'M18 6L6 18M6 6L18 18' : 'M4 18H20M4 6H20H4ZM4 12H20H4Z'}
                stroke={(headerStyle === 'normal' || isOpenMenu) ? "#393939" : 'white' }
                strokeWidth="2" 
                strokeLinecap="round" 
                strokeLinejoin="round"
              />
            </svg>
          </div>
        </div>
      </div>

      <nav className={`w-full h-screen flex flex-col gap-[20px] ${!isOpenMenu && 'hidden'} text-heading1 font-bold bg-white bg-opacity-80 px-[5%] pt-[60px]`}>
        <div 
          onClick={() => window.open('https://www.module-link.com')} 
          className='flex items-center gap-[4px] cursor-pointer'
        >
          만든 사람들
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path 
            d="M9.22173 7H16.9995M16.9995 7V14.7778M16.9995 7L6.99951 17" 
            stroke='#8D8D8D' 
            strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
            />
          </svg>
        </div>
        <NavLink to='/faq'>자주하는 질문</NavLink>
        <NavLink to='/contact'>문의하기</NavLink>
      </nav>
    </header>
  )
}